<template>
  <div id="LgprSurvey">
    <div
      class="slogan"
      @click="$router.push({name: 'login'}).catch((err) => {})"
    >
      Marshall Goldsmith
      Coaching Platform
    </div>

    <LgprSubmittedSurvey v-if="status === 'submitted'" />

    <LgprSurveyConfirmation v-else-if="status === 'just_submitted'" />

    <LgprSurveyForm
      v-else
      :leader="leader"
      :supporter="supporter"
      :status.sync="status"
    />
  </div>
</template>

<script>
import api from '@/api';
import LgprSurveyForm from './LgprSurveyForm.vue';
import LgprSurveyConfirmation from './LgprSurveyConfirmation.vue';
import LgprSubmittedSurvey from './LgprSubmittedSurvey.vue';

export default {
  components: {
    LgprSurveyForm,
    LgprSurveyConfirmation,
    LgprSubmittedSurvey,
  },

  data() {
    return {
      leader: {
        lga1: {},
        lga2: {},
      },
      supporter: {},
      status: '',
    };
  },

  created() {
    this.getSurveyInfo();
  },

  methods: {
    async getSurveyInfo() {
      try {
        const { id } = this.$route.params;
        const response = await api.getSurveyInfo(id);
        this.leader = response.data.leader;
        this.supporter = response.data.supporter;
        this.status = response.data.status;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#LgprSurvey {
  min-height: 100vh;
  overflow: auto;
  padding: 0 0 30px;

  .slogan {
    width: 148px;
    padding: 20px;
    font-style: normal;
    font-weight: bold;
    line-height: normal;
    font-size: 16px;
    color: #fff;
  }
}
</style>
